export default __webpack_public_path__ + "static/media/data_petugas.4d1efc1c.png";